import React from 'react'
import image1 from '../images/insta/1.png'
import image2 from '../images/insta/2.png'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import icon from '../images/icon-9.svg'

export const Cases = () => {
    return (
        <div className='cases' id='case-study'>
            <div className="icon-9">
                <img src={icon} alt="" />
            </div>
            <div className="container">
                <h3
                // className="wow animate__animated animate__bounceInUp"
                // data-wow-duration="0.5s"
                // data-wow-delay="0.2s"
                >Our Case <span>Studies</span></h3>
                {/* <p
                    className='title'
                // className="title wow animate__animated animate__bounceInUp"
                // data-wow-duration="0.5s"
                // data-wow-delay="0.4s"
                >
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit. Culpa aut
                    <br />
                    aliquid quaerat dignissimos rem neque corporis omnis dolor! Harum, repudiandae!
                </p> */}

                <div
                    className='cases-content'
                // className="cases-content wow animate__animated animate__bounceInUp"
                // data-wow-duration="0.5s"
                // data-wow-delay="0.6s"
                >
                    <Swiper
                        slidesPerView={'auto'}
                        spaceBetween={30}
                        loop={true}
                        navigation={{
                            prevEl: '.prev',
                            nextEl: '.next',
                        }}
                        centeredSlides={true}
                        modules={[Navigation]}
                    >
                        <SwiperSlide>
                            <div className="case-main">
                                <div className="top">
                                    <div className="image">
                                        <img src={image1} alt="" className='w-100' />
                                    </div>
                                    <div className="after-before">
                                        <p className='title-top'>Before</p>
                                        <div className="content-af-bf">
                                            <div className="single">
                                                <span>40K</span>
                                                <p>Followers</p>
                                            </div>
                                            <div className="single">
                                                <span>40+</span>
                                                <p>Leads/mo</p>
                                            </div>
                                            <div className="single">
                                                <span>200K</span>
                                                <p>Reach</p>
                                            </div>
                                        </div>
                                        <p className='title-top'>After</p>
                                        <div className="content-af-bf">
                                            <div className="single">
                                                <span>136K</span>
                                                <p>Followers</p>
                                            </div>
                                            <div className="single">
                                                <span>300+</span>
                                                <p>Leads/mo</p>
                                            </div>
                                            <div className="single">
                                                <span>1.5M</span>
                                                <p>Reach</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="bottom">
                                    <p>
                                        Savii struggled to book 30-50 calls per month and was attracting low-quality prospects. Her follower count declined, and engagement was minimal, with just 3-4K saves and shares.
                                    </p>
                                    <p>
                                        We analyzed her past content, identified gaps, and created a data-driven strategy tailored to her audience. Within the first month, results started pouring in; <span className='green'>136K+ new followers organically, 300+ booked calls per month, Saves & shares jumped to 40K-50K.</span> Proper analysis and the right marketing plan made all the difference. {" "}
                                        <span className='green'><a href="https://drive.google.com/file/d/1mC2wPBKmYpYkJvNfzs757hxS4M81F6q2/view?usp=sharing" className="text-green" style={{ textDecoration: 'none' }} target="_blank" rel="noopener noreferrer"><b>View Case Study</b></a></span>
                                    </p>


                                    {/* <ul>
                                        <li>40K+ new followers organically</li>
                                        <li>300+ booked calls per month</li>
                                        <li>Saves & shares jumped to 40K-50K+</li>
                                    </ul> */}
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="case-main">
                                <div className="top">
                                    <div className="image">
                                        <img src={image2} alt="" className='w-100' />
                                    </div>
                                    <div className="after-before">
                                        <p className='title-top'>Before</p>
                                        <div className="content-af-bf">
                                            <div className="single">
                                                <span>90K</span>
                                                <p>Followers</p>
                                            </div>
                                            <div className="single">
                                                <span>400K</span>
                                                <p>Reach</p>
                                            </div>
                                            <div className="single">
                                                <span>7K</span>
                                                <p>Saves/Shares</p>
                                            </div>
                                        </div>
                                        <p className='title-top'>After</p>
                                        <div className="content-af-bf">
                                            <div className="single">
                                                <span>134K</span>
                                                <p>Followers</p>
                                            </div>
                                            <div className="single">
                                                <span>10M</span>
                                                <p>Reach</p>
                                            </div>
                                            <div className="single">
                                                <span>350K</span>
                                                <p>Saves/Shares</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="bottom">
                                    <p>
                                        Our client had been stuck at 90K followers for a year, struggling to generate new leads. Her content wasn’t reaching new audiences, and growth had stalled.
                                    </p>
                                    <p>
                                        After analyzing her past content and promotional strategies, we implemented a fresh marketing plan. In just 90 days, we achieved; <span className='green'>134K new followers organically, 10 million account reach, 5,000 leads generated.</span> This strategic shift unlocked massive growth and real results! {" "}
                                        <span className='green'><a href="https://drive.google.com/file/d/1DjLBCsPm2PUQ115p6b4XqH3PkcGB5Rgt/view?usp=sharing" className="text-green" style={{ textDecoration: 'none' }} target="_blank" rel="noopener noreferrer"><b>View Case Study</b></a></span>
                                    </p>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="case-main">
                                <div className="top">
                                    <div className="image">
                                        <img src={image1} alt="" className='w-100' />
                                    </div>
                                    <div className="after-before">
                                        <p className='title-top'>Before</p>
                                        <div className="content-af-bf">
                                            <div className="single">
                                                <span>40K</span>
                                                <p>Followers</p>
                                            </div>
                                            <div className="single">
                                                <span>40+</span>
                                                <p>Leads/mo</p>
                                            </div>
                                            <div className="single">
                                                <span>200K</span>
                                                <p>Reach</p>
                                            </div>
                                        </div>
                                        <p className='title-top'>After</p>
                                        <div className="content-af-bf">
                                            <div className="single">
                                                <span>136K</span>
                                                <p>Followers</p>
                                            </div>
                                            <div className="single">
                                                <span>300+</span>
                                                <p>Leads/mo</p>
                                            </div>
                                            <div className="single">
                                                <span>1.5M</span>
                                                <p>Reach</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="bottom">
                                    <p>
                                        Savii struggled to book 30-50 calls per month and was attracting low-quality prospects. Her follower count declined, and engagement was minimal, with just 3-4K saves and shares.
                                    </p>
                                    <p>
                                        We analyzed her past content, identified gaps, and created a data-driven strategy tailored to her audience. Within the first month, results started pouring in; <span className='green'>136K+ new followers organically, 300+ booked calls per month, Saves & shares jumped to 40K-50K.</span> Proper analysis and the right marketing plan made all the difference. {" "}
                                        <span className='green'><a href="https://drive.google.com/file/d/1mC2wPBKmYpYkJvNfzs757hxS4M81F6q2/view?usp=sharing" className="text-green" style={{ textDecoration: 'none' }} target="_blank" rel="noopener noreferrer"><b>View Case Study</b></a></span>
                                    </p>


                                    {/* <ul>
                                        <li>40K+ new followers organically</li>
                                        <li>300+ booked calls per month</li>
                                        <li>Saves & shares jumped to 40K-50K+</li>
                                    </ul> */}
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="case-main">
                                <div className="top">
                                    <div className="image">
                                        <img src={image2} alt="" className='w-100' />
                                    </div>
                                    <div className="after-before">
                                        <p className='title-top'>Before</p>
                                        <div className="content-af-bf">
                                            <div className="single">
                                                <span>90K</span>
                                                <p>Followers</p>
                                            </div>
                                            <div className="single">
                                                <span>400K</span>
                                                <p>Reach</p>
                                            </div>
                                            <div className="single">
                                                <span>7K</span>
                                                <p>Saves/Shares</p>
                                            </div>
                                        </div>
                                        <p className='title-top'>After</p>
                                        <div className="content-af-bf">
                                            <div className="single">
                                                <span>134K</span>
                                                <p>Followers</p>
                                            </div>
                                            <div className="single">
                                                <span>10M</span>
                                                <p>Reach</p>
                                            </div>
                                            <div className="single">
                                                <span>350K</span>
                                                <p>Saves/Shares</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="bottom">
                                    <p>
                                        Our client had been stuck at 90K followers for a year, struggling to generate new leads. Her content wasn’t reaching new audiences, and growth had stalled.
                                    </p>
                                    <p>
                                        After analyzing her past content and promotional strategies, we implemented a fresh marketing plan. In just 90 days, we achieved; <span className='green'>134K new followers organically, 10 million account reach, 5,000 leads generated.</span> This strategic shift unlocked massive growth and real results! {" "}
                                        <span className='green'><a href="https://drive.google.com/file/d/1DjLBCsPm2PUQ115p6b4XqH3PkcGB5Rgt/view?usp=sharing" className="text-green" style={{ textDecoration: 'none' }} target="_blank" rel="noopener noreferrer"><b>View Case Study</b></a></span>
                                    </p>
                                </div>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                    <div className="swiper-button-prev prev"></div>
                    <div className="swiper-button-next next"></div>
                </div>
            </div>
        </div>
    )
}
